import { render, staticRenderFns } from "./TvCable.vue?vue&type=template&id=6896f740&scoped=true&"
import script from "./TvCable.vue?vue&type=script&lang=js&"
export * from "./TvCable.vue?vue&type=script&lang=js&"
import style0 from "./TvCable.vue?vue&type=style&index=0&id=6896f740&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896f740",
  null
  
)

export default component.exports